<template>
  <div class="scanCodePay">
    <van-overlay :show="loading">
      <div style="height: 100%;display: flex;align-items: center;justify-content: center;">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
  </div>
</template>


<script>
import {
  ApiCoursewareOrderCreate,
  tradeNoWoSaiPay
} from '../../api/onlineLearning.js'
import { Toast, Loading, Overlay } from 'vant'

export default {
  name: "Pay",
  components: {
    vanLoading: Loading,
    vanOverlay: Overlay,
  },
  data() {
    return {
      coursewareId: null,
      userRecommendNo: null,
      phone: null,
      orderFrom: 2,
      payType: '',
      loading: false,
    }
  },
  created() {
    document.title = '支付'

    // let token = this.$route.query.token
    // if (token) {
      localStorage.setItem('appUserToken', '')
    // }

    this.coursewareId = this.$route.query.coursewareId
    this.userRecommendNo = this.$route.query.userRecommendNo
    this.phone = this.$route.query.phone

    var userAgent = navigator.userAgent
    if (userAgent.indexOf("AlipayClient") > 0) {
      this.payType = "支付宝"
    } else if (userAgent.indexOf("MicroMessenger") > 0) {
      this.payType = "微信"
    }

    this.surePay()
  },
  methods: {
    // 确认支付
    async surePay() {
      let params = {
        coursewareId: this.coursewareId,
        orderFrom: this.orderFrom,
        phone: this.phone
      }

      if (this.userRecommendNo) {
        params.userRecommendNo = this.userRecommendNo
      }

      this.loading = true
      ApiCoursewareOrderCreate(params).then(res1 => {
        console.log('ApiCoursewareOrderCreate', res1)
        if (res1.code === 200) {
          let data = res1.data
          if (data.isPay) {
            Toast('支付成功')
            this.loading = false
          } else {
            console.log('tradeNoWoSaiPay params', {
              tradeNo: data.tradeNo,
              payType: this.payType,
              payPlatForm: 2,
            })
            tradeNoWoSaiPay({
              tradeNo: data.tradeNo,
              payType: this.payType,
              payPlatForm: 2,
            }).then(response => {
              this.loading = false
              console.log('tradeNoWoSaiPay', response)
              if (response) {
                this.loading = false
                if (response.code == 200 && response.data) {
                  window.location.href = response.data
                } else {
                  Toast(response.msg || "交易失败")
                }
              } else {
                Toast("交易失败")
              }
            })
          }
        } else {
          this.loading = false
          Toast(res1.msg || '生成订单失败')
        }
      })
    },
  },
};
</script>

<style lang="scss">
</style>